/**
 * [team 团体票务]
 * @type {Array}
 */
export default [{
  path: 'team',
  name: 'team',
  redirect: 'team/choose_date',
  component: resolve => require(['@/views/team/index'], resolve),
  meta: {
    title: '个人预约',
    auth: false
  },
  children: [{
      path: 'choose_date',
      name: 'team_choose_date',
      component: resolve => require(['@/views/team/chooseDate'], resolve),
      meta: {
        title: '选择参观日期',
        auth: false
      }
    },
    {
      path: 'fill_info',
      name: 'team_fill_info',
      component: resolve => require(['@/views/team/fillInInfo'], resolve),
      meta: {
        title: '填写预约信息',
        auth: true
      }
    },
    {
      path: 'confirm_info',
      name: 'team_confirm_info',
      component: resolve => require(['@/views/team/confirmInfo'], resolve),
      meta: {
        title: '确认预约信息',
        auth: true
      }
    },
    {
      path: 'success',
      name: 'team_success',
      component: resolve => require(['@/views/team/success'], resolve),
      meta: {
        title: '预约成功',
        auth: true
      }
    },
    {
      path: 'order_detail',
      name: 'team_order_detail',
      component: resolve => require(['@/views/team/orderDetail'], resolve),
      meta: {
        title: '预约详情',
        auth: true
      }
    },
  ]
}]



// WEBPACK FOOTER //
// ./src/router/modules/team.js